import React from "react";
import RonaldPhoto from "../assets/img/ronaldpassphoto.png";
import AntonyPhoto from "../assets/img/antonypassport.jpg";
import HighlightImage from "../assets/img/hero.png";
import MarketImage from "../assets/img/market.png";
import BusinessImage from "../assets/img/products.png";
import StatementImage from "../assets/img/st.png";
import FoundersSection from "../components/Sections/FoundersSection";

export default function InvestorPitchPage() {
  return (
    <div className="bg-gray-50 text-gray-900" id="invest">
      
      {/* HERO */}
      <section className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
        <div className="max-w-7xl mx-auto px-6 py-24">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Investing in Regulated Fintech Infrastructure
          </h1>
          <p className="text-xl max-w-3xl mb-8">
            MastaKash is raising capital to scale a compliant digital platform
            powering informal savings and lending groups across Africa.
          </p>
          <a href="/#contact">
             <button className="bg-white text-indigo-700 font-semibold px-8 py-3 rounded-xl shadow hover:bg-gray-100 transition">
            I am interested
          </button>

          </a>

         
        </div>
      </section>

      {/* SHORT SUMMARY */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <h2 className="text-2xl font-semibold mb-4">Short Summary</h2>
        <p className="max-w-4xl text-lg">
          MastaKash is building regulated digital infrastructure that formalizes
          informal savings and lending groups, enabling safe deposits, compliant
          lending, and seamless mobile money integration for millions of
          underserved users.
        </p>
      </section>

      {/* INVESTMENT OVERVIEW */}
      <section className="max-w-7xl mx-auto px-6 pb-16">
        <div className="bg-white rounded-2xl shadow p-8 grid md:grid-cols-3 gap-6">
          <div><strong>Target</strong><br />$500,000</div>
          <div><strong>Minimum Investment</strong><br />$25,000</div>
          <div><strong>Raised to Date</strong><br />$0</div>
          <div><strong>Previous Rounds</strong><br />$0</div>
          <div><strong>Stage</strong><br />MVP / Finished Product</div>
          <div><strong>Investor Role</strong><br />Active/Passive</div>
        </div>
      </section>

      {/* HIGHLIGHTS */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl font-semibold mb-6">Highlights</h2>
            <ul className="space-y-4">
              <li>• Regulatory-first fintech solving real group finance problems</li>
              <li>• Finished product — execution already proven</li>
              <li>• Bank-aligned, low-risk custody model (1:1 ring-fenced funds)</li>
              <li>• Large underserved market with scalable infrastructure</li>
              <li>• Capital-efficient build with strong founder ownership</li>
            </ul>
          </div>

          <div className="flex justify-center">
            <img
              src={HighlightImage}
              alt="Highlights"
              className="max-h-80 w-auto object-contain rounded-xl"
            />
          </div>
        </div>
      </section>

      {/* BUSINESS */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl font-semibold mb-4">The Business</h2>
            <p className="text-lg mb-4">
              MastaKash provides electronic money issuance and retail payment
              services for chamas and organized groups, with all customer funds
              fully ring-fenced in regulated trust accounts held with licensed
              banks.
            </p>
            <p>
              The platform integrates mobile money, transparent accounting,
              approvals, audit trails, and KYC — reducing fraud, errors, and
              cash-based risk while remaining accessible to grassroots users.
            </p>
          </div>

          <img
            src={BusinessImage}
            alt="Product"
            className="max-h-80 w-auto object-contain rounded-xl mx-auto"
          />
        </div>
      </section>

      {/* MARKET */}
      <section className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-2xl font-semibold mb-4">Market Opportunity</h2>
          <p className="text-lg mb-4">
            Tens of millions across East Africa participate in informal savings
            groups moving billions annually, yet remain largely manual and
            unstructured.
          </p>
          <p>
            In Kenya alone, over 300,000 chamas control approximately KES 300
            billion. Regulation and digitization are accelerating demand for
            trusted infrastructure — positioning MastaKash at the center of
            this transition.
          </p>
        </div>

        <img
          src={MarketImage}
          alt="Market"
          className="max-h-80 w-auto object-contain rounded-xl mx-auto"
        />
      </section>

      {/* PROGRESS */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl font-semibold mb-4">Progress & Proof</h2>
            <p className="text-lg mb-4">
              The product is fully built, founder-funded, and operational with
              core modules for groups, savings, loans, accounting, and mobile
              money integration.
            </p>
            <p>
              Over 300 chamas are lined up to onboard post-licensing. The current
              raise focuses on regulatory readiness, partnerships, and controlled
              scale.
            </p>
          </div>

          <img
            src={StatementImage}
            alt="Progress"
            className="max-h-80 w-auto object-contain rounded-xl mx-auto"
          />
        </div>
      </section>

      {/* TEAM */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <FoundersSection/>
       {/* <h2 className="text-2xl font-semibold mb-10">Founding Team</h2>

        <div className="grid md:grid-cols-2 gap-10">
          <div className="flex gap-6 items-start">
            <img src={RonaldPhoto} className="w-24 h-24 rounded-full object-cover" />
            <div>
              <h3 className="text-xl font-semibold">Ronald Wafula</h3>
              <p className="text-indigo-600">Founder, CEO & CTO</p>
              <p className="text-sm mt-2 text-gray-600">
                Leads strategy, technology, and compliance-driven product design,
                with deep experience in financial systems and underserved markets.
              </p>
            </div>
          </div>

          <div className="flex gap-6 items-start">
            <img src={AntonyPhoto} className="w-24 h-24 rounded-full object-cover" />
            <div>
              <h3 className="text-xl font-semibold">Antony</h3>
              <p className="text-indigo-600">Co-Founder</p>
              <p className="text-sm mt-2 text-gray-600">
                Brings extensive cooperative society experience and strong
                networks supporting distribution and partnerships.
              </p>
            </div>
          </div>
        </div>*/}
      </section>

      {/* FINAL CTA */}
      <section className="bg-indigo-600 text-white">
        <div className="max-w-7xl mx-auto px-6 py-16 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Interested in joining the journey?
          </h2>
          <p className="mb-8 text-lg">
            Minimum investment: $25,000 · Regulated · Infrastructure-led
          </p>
         <a href="/#contact">
             <button className="bg-white text-indigo-700 font-semibold px-10 py-4 rounded-xl shadow hover:bg-gray-100 transition">
            I am interested
          </button>
         </a>
        </div>
      </section>
    </div>
  );
}
